
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { deleteCard, getChargeCardDetail } from "@/api/api-non-name";

import { getCountryCodeList } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiHairpinManage extends Vue {
  private formInline: objAny = {
    cardPkId: "",
    accountPkId: "",
    contactName: "",
    phoneNo: "",
    remarks: "",
    accountBalance: "",
    cardSerialNumber: ""
  };

  async deleteCard() {
    const ret = await deleteCard({
      cardPkIdList: [this.formInline.cardPkId]
    });
    if (ret.status === this.$config.apiStatus) {
      if (!ret || !ret.data) {
        return;
      }
      this.$Message.success(i18n.t("cancellation.success"));
      setTimeout(() => {
        this["$router"].push(
          "/member-management/non-real-name-card-management"
        );
      }, 500);
    }
  }

  public handleSubmit() {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("cancellation.successConfirm") + "",
      onOk: () => {
        this.deleteCard();
      }
    });
  }

  // 获取电话区号
  public codeList: any = [];
  async getCodeList() {
    const res = await getCountryCodeList();
    if (res.status === this.$config.apiStatus) {
      this.codeList = res.data || [];
    }
  }
  private isMember = false;
  async getChargeCardDetails(cardPhysicalNumber: string) {
    const res = await getChargeCardDetail({
      cardPhysicalNumber,
      cardSerialNumber: cardPhysicalNumber
    });
    if (res?.data?.length) {
      const data = res.data[0];
      this.isMember = data.memberType == 1;
      data.times = [data.effectiveBeginTime, data.effectiveEndTime];
      this.formInline = data;
    }
  }
  mounted() {
    this.getCodeList();

    const data = this["$common"].get("non-real-name-card-management-item");
    this.getChargeCardDetails(data.cardPhysicalNumber);
  }
}
